/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SoftDatePicker from "components/SoftDatePicker";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: 1,
      bg: false,
    },
    documentNumber: {
      value: "",
      bg: false,
    },
    invoiceNumber : {
      value: "",
      bg: false,
    },
    releaseDate: {
      value: "",
      bg: false,
    },
    departurePort: {
      value: "",
      bg: false,
    },
    arrivalPort: {
      value: "",
      bg: false,
    },
    customer: {
      value: "",
      bg: false,
    },
    customerId: {
      value:"",
      bg: false,
    },
    revenue: {
      value: 0,
      bg: false,
    },
    tax: {
      value: 0,
      bg: false,
    },
    taxExemptions: {
      value: 0,
      bg: false,
    },
  },
];

export default function Table2({setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const options = [
    { value: "options 1"},
    { value: "options 2"},
    { value: "options 3"},
  ];

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;

    const newRow =   {
      bold: false,
      id: {
        value: newIdValue,
        bg: false,
      },
      documentNumber: {
        value: "",
        bg: false,
      },
      invoiceNumber : {
        value: "",
        bg: false,
      },
      releaseDate: {
        value: "",
        bg: false,
      },
      departurePort: {
        value: "",
        bg: false,
      },
      arrivalPort: {
        value: "",
        bg: false,
      },
      customer: {
        value: "",
        bg: false,
      },
      customerId: {
        value:"",
        bg: false,
      },
      revenue: {
        value: 0,
        bg: false,
      },
      tax: {
        value: 0,
        bg: false,
      },
      taxExemptions: {
        value: 0,
        bg: false,
      },
    }
    setData((prev) => [...prev, newRow]);
  };
  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  STT
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Số chứng từ vận chuyển
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                 Hoá đơn
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Cảng đi
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                 Cảng đến
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                  Thông tin khách hàng
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                  Tổng doanh thu vận chuyển thực tế
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                 Số thuế TNDN phải nộp
                </Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                 Số thuế TNDN miễn/ giảm theo hiệp định
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Ngày/ tháng/ năm phát hành</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã số thuế</Th>
              </tr>
              <tr>
              <Th style={{ textAlign: "center" }}></Th>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
                <Th style={{ textAlign: "center" }}>(5)</Th>
                <Th style={{ textAlign: "center" }}>(6)</Th>
                <Th style={{ textAlign: "center" }}>(7)</Th>
                <Th style={{ textAlign: "center" }}>(8)</Th>
                <Th style={{ textAlign: "center" }}>(9)</Th>
                <Th style={{ textAlign: "center" }}>(10)</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((row, index) => (
                  <tr key={row.id.value}>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.id.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                        {row.id.value}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.documentNumber.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.documentNumber.bg ? (
                        row.documentNumber.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="documentNumber"
                          value={row.documentNumber.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.invoiceNumber.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.invoiceNumber.bg ? (
                        row.invoiceNumber.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="invoiceNumber"
                          value={row.invoiceNumber.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.releaseDate.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.releaseDate.bg ? (
                        row.releaseDate.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="releaseDate"
                          value={row.releaseDate.value}
                          onChange={handleChange}
                          type="date"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.departurePort.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.departurePort.bg ? (
                        row.departurePort.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="departurePort"
                          value={row.departurePort.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.arrivalPort.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.arrivalPort.bg ? (
                        row.arrivalPort.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="arrivalPort"
                          value={row.arrivalPort.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.customer.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.customer.bg ? (
                        row.customer.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="customer"
                          value={row.customer.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "center",
                        background: !row.customerId.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.customerId.bg ? (
                        row.customerId.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="customerId"
                          value={row.customerId.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.revenue.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.revenue.bg ? (
                        row.revenue.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="revenue"
                          value={row.revenue.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.tax.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.tax.bg ? (
                        row.tax.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="tax"
                          value={row.tax.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.taxExemptions.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxExemptions.bg ? (
                        row.taxExemptions.value
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="taxExemptions"
                          value={row.taxExemptions.value}
                          onChange={handleChange}
                          type="number"
                        />
                      )}
                    </Td>
                   
                  </tr>
                ))}
              <tr>
                <Td colSpan="8"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >0</Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
              </tr>
            </tbody>
          </table>
        </Box>

        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
